import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxParagraph = _resolveComponent("TpxParagraph")!
  const _component_TpxListingItem = _resolveComponent("TpxListingItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-listing", _ctx.colourClasses])
  }, [
    (_ctx.items && _ctx.items.length == 0)
      ? (_openBlock(), _createBlock(_component_TpxParagraph, {
          key: 0,
          class: "m-listing__no-results text--center",
          content: _ctx.noResultsMessage
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "m-listing__item",
        key: item.href
      }, [
        _createVNode(_component_TpxListingItem, _normalizeProps(_guardReactiveProps(item)), null, 16)
      ]))
    }), 128))
  ], 2))
}